class ShadeFinderQuizLighterShade extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.resultManager = this.resultManager.bind(this)

    this.setupContinueListeners()
    this.setupBackListeners()

    // Listen for when this step is active
    this._observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isActive = mutation.target.classList.contains('is-active')
          this.resultManager(isActive)
        }
      }
    })

    this._observer.observe(this, { attributes: true })
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this._observer?.disconnect()
  }

  // Show next step, and update results based on whether user wants to see true match, lighter shade, both or neither
  setupContinueListeners () {
    const continueBtns = document.querySelectorAll('[data-product-match-section-trigger]')
    const resultProductCards = document.querySelectorAll('[data-shade-finder-product-variant-id]')

    continueBtns.forEach(continueBtn => {
      this.listeners.add(continueBtn, 'click', () => {
        document.querySelector('shade-finder-quiz-lighter-shade').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-product-match').classList.add('is-active')

        // Determine which concealer should show
        const showTrueMatch = continueBtn.getAttribute('data-concealer-true-match')
        const showLighterShade = continueBtn.getAttribute('data-concealer-lighter-shade')
        const skinBaseVariant = continueBtn.getAttribute('data-skin-base-variant-id')
        const trueMatchVariant = continueBtn.getAttribute('data-concealer-true-match-variant-id')
        const lighterShadeVariant = continueBtn.getAttribute('data-concealer-lighter-shade-variant-id')
        const shadeMatrixId = continueBtn.getAttribute('data-shade-matrix-id')

        resultProductCards.forEach(card => {
          card.setAttribute('aria-hidden', 'true')

          const cardVariant = card.getAttribute('data-shade-finder-product-variant-id')
          const cardMatrixId = card.getAttribute('data-shade-finder-result-variant')
          const isComplimentaryProduct = card.classList.contains('sec-ComplimentaryProducts_Product')

          // Always show matching skin base (primary result only)
          if (!isComplimentaryProduct && cardVariant === skinBaseVariant) {
            card.removeAttribute('aria-hidden')
          }

          // Show true match concealer, if enabled (primary result only)
          if (!isComplimentaryProduct && cardVariant === trueMatchVariant && showTrueMatch === 'true') {
            card.removeAttribute('aria-hidden')
          }

          // Show lighter shade concealer, if enabled (primary result only)
          if (!isComplimentaryProduct && cardVariant === lighterShadeVariant && showLighterShade === 'true') {
            card.removeAttribute('aria-hidden')
          }

          // Show complimentary carousel cards based on matching shade matrix IDs
          if (isComplimentaryProduct && (cardMatrixId === 'all' || cardMatrixId?.includes(shadeMatrixId))) {
            if (shadeMatrixId === '') return
            card.removeAttribute('aria-hidden')
          }
        })

        const primaryResults = document.querySelectorAll('[data-shade-finder-result]:not([aria-hidden="true"])')
        const addAllButton = document.querySelector('[data-shade-finder-results-add-all-button]')
        const addButtonText = addAllButton?.querySelector('[data-product-add-to-cart-text]')

        if (!addAllButton || !addButtonText) return

        let availableProducts = 0
        let availableProductsTotalPrice = 0
        this.availableProductIds = []

        primaryResults.forEach(card => {
          if (!card.hasAttribute('aria-hidden')) {
            if (card.getAttribute('data-variant-available') === 'true' && card.querySelector('[data-back-in-stock-item-trigger-id]') == null) {
              availableProducts++
              availableProductsTotalPrice += parseInt(card.getAttribute('data-variant-price'))

              this.availableProductIds.push(card.getAttribute('data-shade-finder-product-variant-id'))
            }
          }
        })

        const formatter = new Intl.NumberFormat(addButtonText.getAttribute('data-locale'), {
          style: 'currency',
          currency: addButtonText.getAttribute('data-currency'),
        })

        availableProductsTotalPrice = formatter.format(availableProductsTotalPrice / 100)

        if (availableProducts === 2) {
          addButtonText.textContent = availableProductsTotalPrice + ' - ' + addButtonText.getAttribute('data-add-two-text')
        }

        if (availableProducts > 2) {
          addButtonText.textContent = availableProductsTotalPrice + ' - ' + addButtonText.getAttribute('data-add-many-text')
        }

        if (availableProducts >= 2) {
          addAllButton.removeAttribute('aria-hidden')
        }

      })
    })

    const addAllButton = document.querySelector('[data-shade-finder-results-add-all-button]')

    if (addAllButton) {
      this.listeners.add(addAllButton, 'click', () => {
        if (!this.availableProductIds || this.availableProductIds.length === 0) return

        this.addToCart(this.availableProductIds.map(id => ({ id: id, quantity: 1 })))
      })
    }
  }

  async addToCart(items) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: items,
        }),
      })

      await response.json()
      const updatedState = await window.BAO.Cart.refreshCart()

      // Dispatch event to update UI
      window.BAO.dispatchEvent(window.BAO.EVENTS.PUSH_CART.AFTER_ADD, {
        state: updatedState,
      })

      // Open the cart drawer
      if (window.drawers) {
        window.drawers.activeDrawerKey = 'cart'
      }
    } catch (err) {
      console.error(err)
    }
  }

  setupBackListeners () {
    const backBtns = document.querySelectorAll('[data-product-match-section-back-trigger]')
    const backBtnsModelfits = document.querySelectorAll('[data-modelfit-section-back-trigger]')

    backBtns.forEach(backBtn => {
      this.listeners.add(backBtn, 'click', () => {
        document.querySelector('shade-finder-quiz-product-match').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-lighter-shade').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-modelfits').classList.add('is-active')

        const radioInputs = document.querySelectorAll('.sec-QuizContent_ModelBlockRadioInput')
        radioInputs.forEach(input => {
          input.checked = false
        })
      })
    })

    backBtnsModelfits.forEach(backBtn => {
      this.listeners.add(backBtn, 'click', () => {
        document.querySelector('shade-finder-quiz-product-match').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-modelfits').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-lighter-shade').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-skintone').classList.add('is-active')
      })
    })
  }

  resultManager(pageActive) {
    if (pageActive !== true){
      if (this.carousel) {
        this.carousel.destroy()
      }
      return
    }
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })

    const resultsSectionTrigger = document.querySelectorAll('[data-product-match-section-trigger]')
    const trueMatchInput = this.els['true-match-input']?.element
    const lighterShadeInput = this.els['lighter-shade-input']?.element

    const saveButton = document.querySelector('[data-shade-finder-quiz-product-match-el="save"]')

    if (saveButton != null && resultsSectionTrigger.length > 0) {
      this.listeners.add(saveButton, 'click', () => {
        const quizResult = resultsSectionTrigger[0].getAttribute('data-shade-matrix-id')

        if (saveButton.getAttribute('data-customer-id') !== null) {
          const { customerId, appUrl, shop } = saveButton.dataset

          this.saveShadeQuizResultToCustomer(customerId, appUrl, shop, quizResult)
        }

        localStorage.setItem('shadeFinderShadeMatrixId', resultsSectionTrigger[0].getAttribute('data-shade-matrix-id'))

        const initialTextContent = saveButton.textContent
        const savedText = saveButton.getAttribute('data-saved-text')

        saveButton.textContent = savedText

        setTimeout(() => {
          saveButton.textContent = initialTextContent
        }, 1500)
      })
    }

    const updateContinueButtons = () => {
      const showTrueMatch = !!trueMatchInput?.checked
      const showLighterShade = !!lighterShadeInput?.checked

      resultsSectionTrigger.forEach(trigger => {
        if (trigger.getAttribute('data-lighter-shade-skip') != null) return
        trigger.setAttribute('data-concealer-true-match', showTrueMatch)
        trigger.setAttribute('data-concealer-lighter-shade', showLighterShade)
      })

      this.updateSelectedShadesCount()
    }

    if (trueMatchInput) {
      this.listeners.add(trueMatchInput, 'click', updateContinueButtons)
      this.listeners.add(trueMatchInput, 'change', updateContinueButtons)
    }

    if (lighterShadeInput) {
      this.listeners.add(lighterShadeInput, 'click', updateContinueButtons)
      this.listeners.add(lighterShadeInput, 'change', updateContinueButtons)
    }

    updateContinueButtons()

    this.carousel = this.setupCarousel()
  }

  async saveShadeQuizResultToCustomer(customerId, appUrl, shopDomain, quizResult) {
    const response = await fetch(appUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        customerId: customerId,
        shop: shopDomain,
        quizResult: quizResult,
      }),
    })

    return response
  }

  updateSelectedShadesCount () {
    const counterElement = document.querySelector('[data-shade-finder-selected-concealer-counter]')
    const selectedOptions = document.querySelectorAll('[data-shade-finder-quiz-lighter-shade-el]:checked')

    counterElement.innerText = selectedOptions.length
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: `${this.els.slide.selector}`,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.5,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 6.5,
            },
            loop: false,
          },
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('shade-finder-quiz-lighter-shade')) {
  customElements.define('shade-finder-quiz-lighter-shade', ShadeFinderQuizLighterShade)
}
